import { SiteLayout } from '@/components/site'
import { Hero } from '@/components/site'
import { PreviewBanner } from '@/components/editable'

export function Home() {
  return (
    <SiteLayout>
      <PreviewBanner />
      <Hero />

      {/* Additional sections can be added here */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900">
              Bienvenue sur notre site
            </h2>
            <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
              Ce site est propulse par CloudCMS, un systeme de gestion de contenu
              leger et gratuit heberge sur Cloudflare.
            </p>
          </div>
        </div>
      </section>
    </SiteLayout>
  )
}
